<template>
  <section id="contact" ref="contact">
    <div class="spacer">
      <div class="big title">{{ contact.title }}</div>
      <div class="pt big pb bb " v-html="contact.address"></div>
      <div class="big pt pb bb ">
        <a target="_blank" :href="contact.facebook">Facebook</a>
      </div>
      <div class="big pt">
        <a target="_blank" :href="contact.instagram">Instagram</a>
      </div>
    </div>
  </section>
</template>

<script>
import API from "@/api/service";
export default {
  data() {
    return {
      contact: []
    };
  },
  created() {
    API.contact(this.$i18n.locale).then(page => {
      this.contact = page.data.result;
    });
  }
};
</script>

<style></style>
